import { FormattedMessage } from 'react-intl';

import { InfoLabel } from '@/modules/forms';
import type { MessageKey } from '@/modules/localizations/translations/types';
import { Spacer } from '@/modules/ui';

import { Fields } from '../../../constants';
import { extractPrivateKeyBlock, extractPublicKeyLine, PUBLIC_KEY_ACCEPT } from '../../../utilities';
import { SshKeyField } from './SshKeyField';

export interface SshKeyFieldsProps {}

const FIELDS = [Fields.PRIVATE_KEY, Fields.PUBLIC_KEY] as const;

const IMPORT_CONFIG: Record<
    (typeof FIELDS)[number],
    { accept?: string; extractKey: (text: string) => string | null; notFoundMessageId: MessageKey }
> = {
    [Fields.PRIVATE_KEY]: {
        extractKey: extractPrivateKeyBlock,
        notFoundMessageId: 'secret.privateKey.import.notFound',
    },
    [Fields.PUBLIC_KEY]: {
        accept: PUBLIC_KEY_ACCEPT,
        extractKey: extractPublicKeyLine,
        notFoundMessageId: 'secret.publicKey.import.notFound',
    },
};

export const SshKeyFields = () => (
    <>
        {FIELDS.map(field => (
            <div key={field}>
                <SshKeyField name={field} {...IMPORT_CONFIG[field]} />

                {field === Fields.PUBLIC_KEY && (
                    <>
                        <Spacer space={0.5} />
                        <InfoLabel>
                            <FormattedMessage id={`secret.${field}.description`} />
                        </InfoLabel>
                    </>
                )}
            </div>
        ))}
    </>
);
